<template>
  <div class="container-xxl bg-white p-0">
    <!-- Navbar -->
    <Navbar />

    <!-- Header Start -->
    <br><br><br>
    <div class="container-fluid header bg-white p-0">
      <div class="row g-0 align-items-center flex-column-reverse flex-sm-row">
        <div class="col-sm-6 p-5 mt-lg-5">
  <h4 class="display-5 animated fadeIn mb-4">
    Find A <span class="text-primary">Perfect Property</span> For You and Your Family
  </h4>
  <p class="animated fadeIn mb-4 pb-2">
    Discover a wide selection of properties tailored to your lifestyle and budget. Whether you're buying or renting, we help you find a safe, comfortable space where lasting memories are made — from homes and apartments to land and commercial spaces.
  </p>
  <router-link class="btn btn-primary py-3 px-5 me-3 animated fadeIn" to="/properties">
    Get Started
  </router-link>
</div>
        <div class="col-sm-6 animated fadeIn">
  <swiper
    :modules="modules"
    :slides-per-view="1"
    :space-between="0"
    :autoplay="{ delay: 4000, disableOnInteraction: false }"
    :pagination="{ clickable: true }"
    class="header-carousel"
    v-if="carouselImages.length && !carouselLoading"
  >
    <swiper-slide v-for="(image, index) in carouselImages" :key="index">
      <div class="position-relative">
        <img class="img-fluid" :src="image.src" :alt="image.alt" />
        <div v-if="image.id" class="position-absolute bottom-0 end-0 m-3">
          <router-link
            :to="'/property-details'"
            @click="storePropertyId(image.id)"
            class="card bg-white bg-opacity-75 border-0 shadow-sm p-2 text-decoration-none"
            style="max-width: 250px;"
          >
            <div class="card-body p-2 text-end">
              <h6 class="card-title mb-1 text-truncate">{{ image.title }}</h6>
              <p class="card-text mb-0 small text-primary">{{ image.status }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </swiper-slide>
  </swiper>
  <div v-else class="text-center">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
      </div>
    </div>
    <!-- Header End -->

    <!-- Search -->
    <SearchFilter />

    <!-- Property List Start -->
    <div class="container-xxl py-5">
      <div class="container">
        <div class="row g-0 gx-5 align-items-end">
          <div class="col-lg-6">
            <div class="text-start mx-auto mb-5 wow slideInLeft" data-wow-delay="0.1s">
              <h1 class="mb-3">Property Listing</h1>
              <p>
                Browse through our latest properties available for sale and rent across Rwanda.
              </p>
            </div>
          </div>
          <div class="col-lg-6 text-start text-lg-end wow slideInRight" data-wow-delay="0.1s">
            <ul class="nav nav-pills d-inline-flex justify-content-end mb-5">
              <li class="nav-item me-2">
                <a
                  class="btn btn-outline-primary"
                  :class="{ active: activeTab === 'featured' }"
                  @click="activeTab = 'featured'; fetchProperties()"
                >Featured</a>
              </li>
              <li class="nav-item me-2">
                <a
                  class="btn btn-outline-primary"
                  :class="{ active: activeTab === 'for-sale' }"
                  @click="activeTab = 'for-sale'; fetchProperties('for_sale')"
                >For Sale</a>
              </li>
              <li class="nav-item me-0">
                <a
                  class="btn btn-outline-primary"
                  :class="{ active: activeTab === 'for-rent' }"
                  @click="activeTab = 'for-rent'; fetchProperties('for_rent')"
                >For Rent</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="tab-content">
          <div class="tab-pane fade" :class="{ 'show active': activeTab === tab }" v-for="tab in ['featured', 'for-sale', 'for-rent']" :key="tab">
            <div class="row g-4" v-if="!loading">
              <div
                v-for="(property, index) in properties"
                :key="property.id"
                class="col-lg-4 col-sm-6 wow fadeInUp"
                :data-wow-delay="`${0.1 + index * 0.2}s`"
              >
                <PropertyCard :property="property" :delay="0.1 + index * 0.2" />
              </div>
              <div class="col-12 text-center wow fadeInUp" data-wow-delay="0.1s" v-if="properties.length">
                <router-link class="btn btn-primary py-3 px-5" to="/properties">
                  Browse More Property
                </router-link>
              </div>
              <div class="col-12 text-center" v-else>
                <p>No properties found.</p>
              </div>
            </div>
            <div v-else class="text-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Property List End -->

    <!-- About Start -->
    <div class="container-xxl py-5">
      <div class="container">
        <div class="row g-5 align-items-center">
          <div class="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
            <div class="about-img position-relative overflow-hidden p-5 pe-0">
              <img class="img-fluid w-100" src="/img/estate-rwanda.png" alt="About Estate Rwanda" />
            </div>
          </div>
          <div class="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
            <h1 class="mb-4">Rwanda’s Gateway to Trusted Real Estate</h1>
            <p class="mb-4">
              Estate Rwanda is your go-to platform for buying, selling, and renting properties across the country. We connect home seekers, investors, and property owners through a seamless and transparent digital experience. Whether you're looking for a family home in Kigali or commercial land in secondary cities, we are here to guide you every step of the way.
            </p>
            <p v-for="feature in aboutFeatures" :key="feature">
              <i class="fa fa-check text-primary me-3"></i>{{ feature }}
            </p>
            <router-link class="btn btn-primary py-3 px-5 mt-3" to="/about">Read More</router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- About End -->

    <!-- Call to Action Start -->
    <div class="container-xxl py-5">
      <div class="container">
        <div class="bg-light rounded p-3">
          <div class="bg-white rounded p-4" style="border: 1px dashed rgba(0, 185, 142, 0.3)">
            <div class="row g-5 align-items-center">
              <div class="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
                <img class="img-fluid rounded w-100" src="/img/real-estate.png" alt="Call to Action" />
              </div>
              <div class="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
                <div class="mb-4">
                  <h1 class="mb-3">Contact Our Certified Agent Today</h1>
                  <p>
                    Ready to find your next home or investment property? Our experienced and certified agents are here to guide you every step of the way. Whether you have questions or want to book a property visit, we're just one call or click away.
                  </p>
                </div>
                <router-link class="btn btn-primary py-3 px-4 me-2" to="/contact">
                  <i class="fa fa-phone-alt me-2"></i>Make A Call
                </router-link>
                <router-link class="btn btn-dark py-3 px-4" to="/appointment">
                  <i class="fa fa-calendar-alt me-2"></i>Get Appointment
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Call to Action End -->

    <!-- Category Start -->
    <div class="container-xxl py-5">
      <div class="container">
        <div class="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style="max-width: 600px">
          <h1 class="mb-3">Explore Property Types</h1>
          <p>
            Discover a wide range of property categories tailored to meet your needs. Estate Rwanda helps you find the perfect space, whether you're buying, renting, or investing across Rwanda.
          </p>
        </div>
        <div class="row g-4" v-if="!loading">
          <div
            v-for="(category, index) in categories"
            :key="category.name"
            class="col-lg-3 col-sm-6 wow fadeInUp"
            :data-wow-delay="`${0.1 + index * 0.2}s`"
          >
            <router-link class="cat-item d-block bg-light text-center rounded p-3" to="/properties">
              <div class="rounded p-4">
                <div class="icon mb-3">
                  <img class="img-fluid" :src="category.icon" :alt="category.name" />
                </div>
                <h6>{{ category.name }}</h6>
                <span>{{ category.count }} Properties</span>
              </div>
            </router-link>
          </div>
        </div>
        <div v-else class="text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Category End -->

    <!-- Team Start -->
    <div class="container-xxl py-5">
      <div class="container">
        <div class="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style="max-width: 600px">
          <h1 class="mb-3">Our Agents</h1>
          <p>
            Our agents offer personalized guidance, reliable support, and expert advice—making your buying, renting, or selling journey seamless and stress-free.
          </p>
        </div>
        <div class="row g-4" v-if="!loading">
          <div
            v-for="(agent, index) in agents"
            :key="agent.id"
            class="col-lg-3 col-sm-6 wow fadeInUp"
            :data-wow-delay="`${0.1 + index * 0.2}s`"
          >
            <div class="team-item rounded overflow-hidden">
              <div class="position-relative">
                <img class="img-fluid" :src="agent.image" :alt="agent.name" />
                <div class="position-absolute start-50 top-100 translate-middle d-flex align-items-center">
                  <a class="btn btn-square mx-1" :href="agent.social.facebook">
                    <i class="fab fa-facebook-f"></i>
                  </a>
                  <a class="btn btn-square mx-1" :href="agent.social.twitter">
                    <i class="fab fa-twitter"></i>
                  </a>
                  <a class="btn btn-square mx-1" :href="agent.social.instagram">
                    <i class="fab fa-instagram"></i>
                  </a>
                </div>
              </div>
              <div class="text-center p-4 mt-3">
                <h5 class="fw-bold mb-0">{{ agent.name }}</h5>
                <small>{{ agent.designation }}</small>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Team End -->

    <!-- Footer -->
    <Footer />

    <!-- Back to Top -->
    <a href="#" class="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top">
      <i class="bi bi-arrow-up"></i>
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, Pagination } from 'swiper/modules'
import api from '../services/api'
import Navbar from './NavBar.vue'
import Footer from './FooterItem.vue'
import SearchFilter from './SearchFilter.vue'
import PropertyCard from './PropertyCard.vue'
import type { CarouselImage, Property, Agent, PropertyType } from '../types'
import seoMixin from '../mixins/seoMixin'
import seoService from '../services/seo'

export default defineComponent({
  components: { Swiper, SwiperSlide, Navbar, Footer, SearchFilter, PropertyCard },
  mixins: [seoMixin],
  setup () {
    const modules = [Autoplay, Pagination]
    const carouselImages = ref<CarouselImage[]>([])
    const categories = ref<PropertyType[]>([])
    const aboutFeatures = ref([
      'Verified and up-to-date property listings',
      'Professional agents with local expertise',
      'Easy-to-use platform with map and photo features',
      'Support for both rentals and sales across Rwanda'
    ])
    const properties = ref<Property[]>([])
    const agents = ref<Agent[]>([])
    const activeTab = ref('featured')
    const loading = ref(true)
    const carouselLoading = ref(true)

    const fetchProperties = async (saleType: string | null = null) => {
      try {
        const params: { saleType?: string; limit?: number } = { limit: 6 }
        if (saleType) {
          params.saleType = saleType
        }
        const response = await api.get('/estate/properties', { params })
        properties.value = response.data

        // Populate carouselImages with unique property images and details
        const uniqueImages = [...new Set(properties.value.map(prop => prop.image))]
          .filter(image => image !== '/img/default-property.jpg')
          .slice(0, 4)
          .map((image, index) => {
            const property = properties.value.find(prop => prop.image === image)
            return {
              id: property?.id,
              src: image,
              alt: property?.title || `Featured Property ${index + 1}`,
              title: property?.title,
              status: property?.status
            }
          })

        carouselImages.value = uniqueImages.length
          ? uniqueImages
          : [
              { src: '/img/carousel-1.jpg', alt: 'Property 1' },
              { src: '/img/carousel-2.jpg', alt: 'Property 2' }
            ]
      } catch (error) {
        console.error('Error fetching properties:', error)
        properties.value = []
        carouselImages.value = [
          { src: '/img/carousel-1.jpg', alt: 'Property 1' },
          { src: '/img/carousel-2.jpg', alt: 'Property 2' }
        ]
      } finally {
        carouselLoading.value = false
      }
    }

    const fetchData = async () => {
      try {
        // Fetch property types
        const propertyTypesResponse = await api.get('/estate/property-types')
        categories.value = propertyTypesResponse.data

        // Fetch agents
        const agentsResponse = await api.get('/estate/agents', { params: { limit: 4 } })
        agents.value = agentsResponse.data

        // Fetch featured properties and carousel images
        await fetchProperties()
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        loading.value = false
      }
    }

    const storePropertyId = (id: number) => {
      localStorage.setItem('propertyId', id.toString())
    }

    onMounted(() => {
      window.scrollTo(0, 0) // Scroll to top
      fetchData()
    })

    // Set SEO for homepage
    seoService.setHomeSEO()

    return {
      modules,
      carouselImages,
      carouselLoading,
      categories,
      aboutFeatures,
      properties,
      agents,
      activeTab,
      fetchProperties,
      loading,
      storePropertyId
    }
  }
})
</script>

<style scoped>
.header-carousel {
  max-height: 100%;
}
.header-carousel :deep(.swiper-slide img) {
  width: 100%;
  object-fit: cover;
}
:deep(.swiper-pagination-bullet-active) {
  background-color: #0d6efd;
}
.back-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 99;
}
.card {
  transition: transform 0.2s;
}
.card:hover {
  transform: scale(1.05);
}
</style>
